import { Navigate } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "context/AuthContext";
import { ROLES } from "utils/constants";

/**
 * Route guard for the PureBrand (platform) admin portal.
 *
 * PureBrand admins are not a store team role and hold no store capabilities,
 * so their pages are gated on the role itself. Store-side pages use
 * RequireCapability instead.
 */
const PurebrandAdminRoute = ({ children }) => {
  let { user, loggedIn } = useContext(AuthContext);
  if ((!user && !loggedIn) || user?.role !== ROLES.PUREBRAND_ADMIN.role) {
    return <Navigate to="/user/welcome" replace />;
  }
  return children;
};

export default PurebrandAdminRoute;
